import SessionManager from '../routes/SessionManager';

function Procore() {
    
    var sessionManager = new SessionManager();
    var userData = sessionManager.readCookie('user', false);
    if (userData)
        window.location = "/";
    else {
        let searchParams = new URL(window.location).searchParams;
        let company_proj = searchParams.get('cp');
        let procore_url = 'https://login.procore.com/oauth/authorize?client_id=3e1ca11c1bea250d7b79c5f3ff6c759b8b606643b1a95460e102267354310e2a&response_type=code&redirect_uri=https://www.sitesupt.com/settings?cp=' + company_proj;
        window.open(procore_url);
    }

    return "Authorization in progress ..."
}

export default Procore;